interface GlobalStyleObserverOptions {
  shadowRoot: ShadowRoot | null;
  getGlobalStyleSheets: () => CSSStyleSheet[];
}

const setupGlobalStyleObserver = ({
  shadowRoot,
  getGlobalStyleSheets,
}: GlobalStyleObserverOptions) => {
  const isDevelopment = import.meta.env.DEV;
  if (!shadowRoot || !document.head || !isDevelopment) {
    return;
  }

  const syncGlobalStyles = () => {
    if (shadowRoot.adoptedStyleSheets) {
      const root = shadowRoot;
      root.adoptedStyleSheets = getGlobalStyleSheets();
    }
  };

  const observer = new MutationObserver(syncGlobalStyles);
  const observerConfig: MutationObserverInit = {
    childList: true,
    subtree: true,
  };
  observer.observe(document.head, observerConfig);
  syncGlobalStyles();
};

export default setupGlobalStyleObserver;
